
import BotonWhatsapp from "../components/BotonWhatsapp";

function Contacto() {
  return (
    <div>
     
      
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 mt-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl font-bold mb-6">
            Contáctanos
          </h1>
          <p className="text-xl mb-8">
            Estamos ubicados en Pujilí y listos para atenderte
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12">
              {/* Información de Contacto */}
              <div>
                <h2 className="text-3xl font-bold mb-8 text-gray-800">
                  Información de Contacto
                </h2>
                
                <div className="space-y-6">
                  <div className="bg-white rounded-lg shadow-lg p-6">
                    <div className="flex items-center mb-4">
                      <span className="text-3xl mr-4">📍</span>
                      <div>
                        <h3 className="text-lg font-semibold">Dirección</h3>
                        <p className="text-gray-600">Calle Pichincha y Zoila Victoria</p>
                        <p className="text-gray-600">Pujilí, Ecuador</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg shadow-lg p-6">
                    <div className="flex items-center mb-4">
                      <span className="text-3xl mr-4">📞</span>
                      <div>
                        <h3 className="text-lg font-semibold">Teléfono</h3>
                        <a href="tel:0998106377" className="text-blue-600 text-lg font-semibold hover:text-blue-800">
                          099 810 6377
                        </a>
                        <p className="text-gray-600 text-sm">Lunes a Domingo 8AM - 6PM</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg shadow-lg p-6">
                    <div className="flex items-center mb-4">
                      <span className="text-3xl mr-4">💬</span>
                      <div>
                        <h3 className="text-lg font-semibold">WhatsApp</h3>
                        <a 
                          href="https://wa.me/593998106377?text=Hola Betalink, necesito información"
                          className="text-green-600 text-lg font-semibold hover:text-green-800"
                        >
                          +593 99 810 6377
                        </a>
                        <p className="text-gray-600 text-sm">Respuesta inmediata</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Promoción y Horarios */}
              <div>
                <h2 className="text-3xl font-bold mb-8 text-gray-800">
                  Promoción Especial
                </h2>
                
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
                  <h3 className="text-xl font-bold text-yellow-800 mb-4">
                    🎉 ¡3 Meses Promocionales!
                  </h3>
                  <ul className="space-y-2 text-yellow-700">
                    <li>• Plan Básico: 400 Mbps - $15.39</li>
                    <li>• Plan Estudiante: 600 Mbps - $17.70</li>
                    <li>• Plan Tecnología: 800 Mbps - $23.30</li>
                    <li>• Plan Gamer: 1000 Mbps - $30.60</li>
                  </ul>
                </div>

                <div className="bg-white rounded-lg shadow-lg p-6">
                  <h3 className="text-xl font-bold mb-4">Horarios de Atención</h3>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="font-semibold">Lunes - Viernes</span>
                      <span className="text-gray-600">8:00 AM - 6:00 PM</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold">Sábado</span>
                      <span className="text-gray-600">8:00 AM - 5:00 PM</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold">Domingo</span>
                      <span className="text-gray-600">9:00 AM - 4:00 PM</span>
                    </div>
                  </div>
                </div>

                <div className="mt-6 space-y-4">
                  <a 
                    href="tel:0998106377"
                    className="w-full bg-green-500 hover:bg-green-600 text-white py-4 rounded-lg font-semibold transition-colors text-center block"
                  >
                    📞 Llamar Ahora
                  </a>
                  <a 
                    href="https://wa.me/593998106377?text=Hola Betalink, quiero información sobre la promoción de 3 meses"
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 rounded-lg font-semibold transition-colors text-center block"
                  >
                    💬 WhatsApp - Promoción
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BotonWhatsapp />
    </div>
  );
}

export default Contacto;